/**
 * Shared markdown-lite renderer for all Aura cards.
 * Text uses var(--text-*) — wrap in .light-surface on dark panels, or rely on page :root.
 */
import React from 'react';

export const stripThinkingClient = (text) => {
  if (!text) return '';
  return text
    .replace(/<(?:thought|thinking)>[\s\S]*?<\/(?:thought|thinking)>/gi, '')
    .replace(/<(?:thought|thinking)>[\s\S]*$/gi, '')
    .replace(/\n{3,}/g, '\n\n')
    .trim();
};

const BULLET = {
  light: 'text-pine',
  'on-dark': 'text-secondary',
};

export const AuraFormattedText = ({ content, className = '', tone = 'light' }) => {
  const cleaned = stripThinkingClient(content);
  if (!cleaned) return null;

  const bullet = BULLET[tone] || BULLET.light;
  const lines = cleaned.split('\n');
  const elements = [];

  lines.forEach((line, idx) => {
    if (line.startsWith('## ')) {
      elements.push(
        <h2 key={idx} className={`font-display text-h3 text-primary mt-4 mb-2`}>
          {line.replace(/^##\s+/, '')}
        </h2>
      );
    } else if (line.startsWith('### ')) {
      elements.push(
        <h3 key={idx} className={`font-sans text-h3 text-primary mt-3 mb-1`}>
          {line.replace(/^###\s+/, '')}
        </h3>
      );
    } else if (line.includes('**')) {
      const parts = line.split(/(\*\*.*?\*\*)/g);
      elements.push(
        <p key={idx} className="mb-2 leading-relaxed text-body text-primary">
          {parts.map((part, pIdx) =>
            part.startsWith('**') && part.endsWith('**') ? (
              <strong key={pIdx} className="font-medium text-primary">
                {part.replace(/\*\*/g, '')}
              </strong>
            ) : (
              <span key={pIdx}>{part}</span>
            )
          )}
        </p>
      );
    } else if (line.trim().startsWith('- ') || line.trim().startsWith('• ')) {
      elements.push(
        <div key={idx} className={`ml-3 mb-1.5 flex items-start gap-2 text-body text-secondary`}>
          <span className={`${bullet} shrink-0`}>·</span>
          <span>{line.replace(/^[-•]\s+/, '')}</span>
        </div>
      );
    } else if (line.trim()) {
      elements.push(
        <p key={idx} className="mb-2 leading-relaxed text-body text-primary">
          {line}
        </p>
      );
    } else {
      elements.push(<br key={idx} />);
    }
  });

  return <div className={className}>{elements}</div>;
};

export default AuraFormattedText;
